import { Box } from "@mui/material";
import React from "react";
import useSWR from "swr";
import { useSelector } from "react-redux";

import ProfileHeaderNavBar from "../../../components/EditProfile/HeaderNavBar";
import EditProfileInputs from "../../../components/EditProfile/Inputs";
import ProfilePicture from "../../../components/EditProfile/ProfilePicture";
import { getSettingState } from "../../../../redux/features/settingSlice";
import UseWindowDimensions from "../../../../utils/windowSize";
import CustomHelmet from "../../../components/CustomHelmet";

const EditProfile = () => {
  const { userData } = useSelector(getSettingState);
  const { height } = UseWindowDimensions();

  const { data: profile } = useSWR(
    () => {
      if (!userData) {
        return null;
      }
      return `${process.env.REACT_APP_API}/auth/profile/${userData}/`;
    },
    {
      dedupingInterval: 1000,
    }
  );

  return (
    <>
      <CustomHelmet title={`Edit information | Profile`} />

      <Box
        sx={{
          height: height + "px",
          overflowY: "auto",
          paddingX: "16px",
          backgroundColor: "white.main",
        }}
      >
        <ProfileHeaderNavBar />
        <ProfilePicture profile={profile} />
        <EditProfileInputs profile={profile} />
      </Box>
    </>
  );
};

export default EditProfile;
